import { render, staticRenderFns } from "./DashboardRh.vue?vue&type=template&id=cb449822&"
import script from "./DashboardRh.vue?vue&type=script&lang=js&"
export * from "./DashboardRh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports